"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TWO_ONE = exports.SHESH_BESH = exports.BACKGAMMON_POINT_THRESHOLD = exports.DOUBLE_STEP_COUNT = exports.TOTAL_CHECKERS = exports.HOME_BOARD_SIZE = exports.NUM_POINTS = exports.OFF_POINT = exports.BAR_POINT = void 0;
const Model_1 = require("./Model");
Object.defineProperty(exports, "BAR_POINT", { enumerable: true, get: function () { return Model_1.BAR_POINT; } });
Object.defineProperty(exports, "OFF_POINT", { enumerable: true, get: function () { return Model_1.OFF_POINT; } });
// The 24 numbered board points (1..24); OFF_POINT (0) and BAR_POINT (25) bracket them.
exports.NUM_POINTS = 24;
// A player's home board is points 1..6. `point <= HOME_BOARD_SIZE` ⇔ checker is home.
exports.HOME_BOARD_SIZE = 6;
// Each player has 15 checkers; all 15 off the board ⇒ that player has won.
exports.TOTAL_CHECKERS = 15;
// A double roll yields four steps instead of two.
exports.DOUBLE_STEP_COUNT = 4;
// Backgammon (triple) win: the loser still has a checker on a point > this threshold
// (i.e. in the winner's home quadrant / on the bar). 18 = NUM_POINTS - HOME_BOARD_SIZE.
exports.BACKGAMMON_POINT_THRESHOLD = 18;
// Roro special rolls.
exports.SHESH_BESH = [6, 5];
exports.TWO_ONE = [2, 1];
